import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { resetFinalWinner } from 'slices/finalWinnerSlice';
import { removeErrorCP } from 'slices/postalCodeSlice';

const AlertDanger = ({ heading, body, type }) => {
  const dispatch = useDispatch();
  const handleClose = () => {
    if (type === 'General') {
      dispatch(resetFinalWinner());
    }
    if (type === 'postalCode') {
      dispatch(removeErrorCP());
    }
  };

  return (
    <div className="alert custom-alert-danger alert-dismissible fade show" role="alert">
      <h5 className="alert-heading">
        <i className="fa fa-times-circle mr-2" aria-hidden="true" />
        {heading}
      </h5>
      <p className="alert-text">{body}</p>
      <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={handleClose}>
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
};

AlertDanger.propTypes = {
  heading: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default AlertDanger;
